<script lang="ts" setup>
import Account from '@/components/settings/Account.vue'
import DeviceActivity from '@/components/settings/DeviceActivity.vue'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
</script>

<template>
    <DefaultLayout :title="$t('settings.accountSettings')">
        <prizific-title-description :title="$t('settings.profile')" titleBold />
        <Account id="account" />
        <prizific-title-description :title="$t('settings.deviceActivity')" titleBold />
        <DeviceActivity id="device-activity" />
        <!-- <Layout id="layout" /> -->
    </DefaultLayout>
</template>

<style lang="scss" scoped></style>
